
export const LoadingConst ={
    colorPrimary: 'black',
    colorSecondary:'white'
}
